<script lang="ts">
	import { onMount } from "svelte";
	import { listFavourites } from "@stores/favourites";

	export let functionToBeCalled: "listFavourites";
	onMount(() => {
		switch (functionToBeCalled) {
			case "listFavourites":
				listFavourites();
			default:
				break;
		}
	});
</script>
